import { createSlice } from "@reduxjs/toolkit";

const voteNowSlice = createSlice({
  name: "voteNow",
  initialState: {
    loading: false,
    error: false,
    isVoteNowPopup: false,
    voteNowPot: {
      pot: "",
      pick: "",
      vote: "",
      logo: "",
    },
  },
  reducers: {
    updateLoadingStatus: (state) => {
      state.loading = true;
    },
    updateErrStatus: (state) => {
      state.loading = false;
      state.error = true;
    },
    updateVoteNowPopup: (state, action) => {
      state.isVoteNowPopup = action.payload.isOpenPopup;
      state.voteNowPot = {
        pot: action.payload.potId,
        pick:action.payload.pickId
      };
    },
    updateVoteDetail: (state, action) => {
      state.voteNowPot = {
        pot: action.payload.pot,
        pick: action.payload.pick,
        vote: action.payload.vote,
        logo: action.payload.logo,
      };
    },
  },
});

export const {
  updateConfirmPopup,
  updateLoadingStatus,
  updateVoteDetail,
  updateVoteNowPopup,
} = voteNowSlice.actions;

export default voteNowSlice.reducer;
